import app from './app';
import './css/app.css';

let env = process.env.NODE_ENV;
// let api =  process.env.API_BASEURL
// console.log(api);
if(env !=="development")
{
   new app();
}
export default app;